import { useQuery } from "@tanstack/react-query";
import { OwnScenario } from "@/model";
import scenarioRepository from "@/repository/scenarioRepository";
import { scenarioQueryKeys } from "./keys";


const getData = async () => {
    const response = await scenarioRepository.findPage(0, 10);
    return response.data?.content || [];
};

export const useRecentScenarios = () => {
    return useQuery<OwnScenario[]>({
        queryKey: scenarioQueryKeys.recent(),
        queryFn: async () => getData(),
        retry: false
    });
};
